webpackJsonp([209714949778103],{

/***/ 656:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Models = __webpack_require__(18);
	
	var _Models2 = _interopRequireDefault(_Models);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Models2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Introduction'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Models are part of the ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/lore/lore/tree/master/packages/lore-models' },
	        'lore-models'
	      ),
	      ' package, and are an abstraction for interacting with a REST API endpoint that make it easier to create, update, destroy or retrieve a resource.'
	    ),
	    _react2.default.createElement(
	      'blockquote',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'The interface and behavior for Models is ',
	        _react2.default.createElement(
	          'em',
	          null,
	          'heavily'
	        ),
	        ' inspired by ',
	        _react2.default.createElement(
	          'a',
	          { href: 'http://backbonejs.org/#Model' },
	          'Backbone.Model'
	        ),
	        ', and you can learn more the reasons why ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/models/misc/history' },
	          'here'
	        ),
	        '.'
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-models-index-js-47e12f7ed750c9423116.js